import { render, staticRenderFns } from "./TypeOwner.vue?vue&type=template&id=309585a0&"
import script from "./TypeOwner.vue?vue&type=script&lang=ts&"
export * from "./TypeOwner.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports